import { render } from "./Modal3.vue?vue&type=template&id=4763c0a8"
import script from "./Modal3.vue?vue&type=script&lang=js"
export * from "./Modal3.vue?vue&type=script&lang=js"

import "./Modal3.vue?vue&type=style&index=0&id=4763c0a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__